<script setup>
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-dialog 
    v-model="media"
    width="700px"
>
<v-card v-if="media_detail != null"
    width="700px"
>
<v-toolbar
    flat
    color="#E11D31"
    dark
>
    <v-toolbar-title>
        {{ media_detail.title }}
    </v-toolbar-title>
    <v-spacer />
    <v-icon
        @click="media=false"
    >
        mdi-close
    </v-icon>
</v-toolbar>
<v-card-text>
<div class="media_detail_box">
    <div class="media_detail_img">
      <v-img
        :src="`https://search.qlipper.jp/cont/mdimg?site_id=` + media_detail.id"
        :aspect-ratio="16/9"
        class="grey lighten-2 rounded-lg"
        style="text-align:end;"
      >
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0"
            align="center"
            justify="center"
          >
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>

    </div>
    <div class="media_detail_info" >
        <v-card outlined flat width="100%">
        <v-card-text class="py-3 px-3">
        <p >{{ media_detail.site_url }}</p>
        <div class="project-result-list__info">
            <ul class="result_media_summary">
                   <li v-for="corps,index in disp_op_corp(media_detail.op_ids,media_detail.op_corp_names)" :key="index">
                    <span class="media_corp_name" ><a  href="javascript:void(0)" v-on:click="corp(corps.id)">{{ corps.name }}</a></span>
                </li>
            </ul>
        </div>
        <div class="media_result" v-if="media_detail.doc_pfm != '-'">
            <div class="media_result_info" >
                <span class="media_result_data" v-if="media_detail.doc_pfm != '-'">{{  Number(media_detail.doc_pfm).toLocaleString()  }}記事</span><span class="project-result-list__date-text"  v-else>-</span>
                <span class="media_result_data" v-if="media_detail.doc_view != '-'" >{{  Number(media_detail.doc_view).toLocaleString()  }}pv</span><span class="project-result-list__date-text"  v-else>-</span>
            </div>
        </div>
        </v-card-text>
        </v-card>
     </div>
</div>
        <div class="sns_account">
            SNS等アカウント:
            <span v-for="data,index in disp_account_data(media_detail.account)" :key="index">
                <span v-if="index == 0" >公式アカウント</span>
                <span v-else-if="index == 1">代表（編集長）</span>
                <span v-else>編集者・ライター</span>
                <a href="javascript:void(0)" v-if="data != 0" v-on:click="snsdsp(media_detail.id)"><span class="account_num">{{ data }}</span></a>
                <span class="account_num" v-else>{{ data }}</span>
            </span>
        </div>

<div class="project-result-list__info">

      </div>
      <div class="project-result-list__info">
        <v-card outlined flat width="100%">
               <v-card-text>{{ media_detail.ogp_discription }}</v-card-text>
        </v-card>
      </div>
   <div class="project-list-table-box">
    <table class="common-table">
     <thead class="common-table__head">
      <tr class="common-table__head-row">
       <th class="common-table__head-title -tx-left">サイトステータス</th>
       <th class="common-table__head-title -status"></th>
      </tr>
     </thead>
     <tbody class="common-table__body">
      <tr class="common-table__body-row"  >
       <td class="common-table__body-data -tx-left">分類</td>
       <td class="common-table__body-data -nowrap">{{ media_detail.label }}</td>
      </tr>
      <tr class="common-table__body-row"  >
       <td class="common-table__body-data -tx-left">サイト規模</td>
       <td class="common-table__body-data -nowrap">{{ media_detail.scl }}</td>
      </tr>
      <tr class="common-table__body-row"  >
       <td class="common-table__body-data -tx-left">閲覧者数</td>
       <td class="common-table__body-data -nowrap">{{ media_detail.pv }}</td>
      </tr>
      <tr class="common-table__body-row"  >
       <td class="common-table__body-data -tx-left">ツイート</td>
       <td class="common-table__body-data -nowrap">{{ media_detail.tweet }}</td>
      </tr>
      <tr class="common-table__body-row"  >
       <td class="common-table__body-data -tx-left">月間総ページビュー</td>
       <td class="common-table__body-data -nowrap">{{ Number(media_detail.page_view).toLocaleString() }}</td>
      </tr>
     </tbody>
    </table>
   </div>
   <div class="project-list-table-box">
    <table class="common-table">
     <thead class="common-table__head">
      <tr class="common-table__head-row">
       <th class="common-table__head-title -tx-left">サイト状態</th>
       <th class="common-table__head-title -status"></th>
      </tr>
     </thead>
     <tbody class="common-table__body">
      <tr class="common-table__body-row"  >
       <td class="common-table__body-data -tx-left">週間記事数</td>
       <td class="common-table__body-data -nowrap">{{ Number(media_detail.doc_num).toLocaleString() }}</td>
      <tr class="common-table__body-row"  >
       <td class="common-table__body-data -tx-left">週間ツイート引用数</td>
       <td class="common-table__body-data -nowrap">{{ media_detail.tweet_num }}</td>
      </tr>
      <tr class="common-table__body-row"  >
       <td class="common-table__body-data -tx-left">ALEXAランク</td>
       <td class="common-table__body-data -nowrap">{{ media_detail.alexa_rank }}</td>
      </tr>
     </tbody>
    </table>
   <div class="project-list-table-box" v-if="reprint_site.length != 0">
        <div class="tagbox">
            <table class="common-table" >
             <thead class="common-table__head">
                  <tr class="common-table__head-row">
                       <th class="common-table__head-title -tx-left">主要転載サイト ({{ reprint_site.length }}サイト)</th>
                       <th class="common-table__head-title -status"></th>
                  </tr>
             </thead>
             <tbody class="common-table__body">
                  <tr class="common-table__body-row"  v-for="reprint,index in reprint_site" :key="index">
                       <td class="common-table__body-data -nowrap -tx-left"><a href="javascript:void(0)" v-on:click="mediaopen(reprint.id)">{{ reprint.site_name }}</a></td>
                       <td class="common-table__body-data -nowrap">{{ reprint.sum_cnt.toLocaleString() }}</td>
                  </tr>
             </tbody>
            </table>
           </div>
  </div>
</div>
</v-card-text>
</v-card>
</v-dialog>
</template>
<script>
export default {
    data : function(){
        return {
            media : false,
            media_detail : null,
            reprint_site : [],
        };
    },
    methods : {
        view_tag: function(text) {
            
            if(text == null || text == '')
            {
                return null;
            }
            let tags = text.split(',');
            return tags;
        },
        corp      : function(id){
            this.$emit("cdsp",{id:id});
            this.media=false;
        },
        snsdsp      : function(id){
            this.$emit("snsdsp",{id:id});
            this.media=false;
        },
        mediaopen : function(site_id){
            let params = new URLSearchParams();
            params.append('site_id',site_id);

            axios.post("/api/media/get_media",params)
            .then(response => {
                this.media_detail = response.data;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
            this.reprint_site = [];

            axios.post("/api/reprint/get_reprint_site",params)
            .then(response => {
                this.reprint_site = response.data;
                this.media = true;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        disp_op_corp : function (op_ids,op_names) {
            if (op_ids === '')
            {
                return "";
            }
            let data = Array();
            let ids = Array();
            let names = Array();
            if(op_ids != null)
                ids = op_ids.toString().split(',');
            if(op_names != null)
                 names = op_names.split(',');
            for(let i = 0 ; i < ids.length ; i++)
            {
                data.push({id:ids[i],name:names[i]});
            }
            return data;
        },
        disp_account_data : function (account_string){
            if (account_string === '')
            {
                return "";
            }
            let data = Array();
            data = account_string.toString().split(',');

            return data;
        },
    },
    updated() {
        const elements = document.getElementsByClassName('v-dialog--active');
        if (!elements || !elements.length) {
          // 要素が取得できなかった場合は終了
          return;
        }   
        elements[0].scrollTop = 0;
    },
}
</script>
